export default __webpack_public_path__ + "static/media/LL.58e8a9e8.png";